import { translate } from '@/utils/translations'

const TaxLoader = () => (
  <>
    {translate('carts.calculating_taxes')}
    <div className='sk-spinner sk-spinner-three-bounce ocean-theme'>
      <div className='sk-bounce1' />
      <div className='sk-bounce2' />
      <div className='sk-bounce3' />
    </div>
  </>
)

export default TaxLoader
